import { useState } from "react";
import PropTypes from "prop-types";
import {
  NavLink as RouterLink,
  matchPath,
  useLocation,
} from "react-router-dom";
import { alpha, useTheme, styled } from "@mui/material/styles";
import {
  Box,
  List,
  Collapse,
  ListItemText,
  ListItemIcon,
  ListItemButton,
  Icon,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

const ListItemStyle = styled((props) => (
  <ListItemButton disableGutters {...props} />
))(({ theme }) => ({
  ...theme.typography.body2,
  height: 48,
  position: "relative",
  textTransform: "capitalize",
  paddingLeft: theme.spacing(5),
  paddingRight: theme.spacing(2.5),
  color: theme.palette.text.secondary,
  "&:hover": {
    color: theme.palette.text.primary,
    // backgroundColor: alpha(
    //   theme.palette.primary.main,
    //   theme.palette.action.hoverOpacity
    // ),
    backgroundColor: "#4C3795",
  },
  "&:before": {
    top: 0,
    right: 0,
    width: 3,
    bottom: 0,
    content: "''",
    display: "none",
    position: "absolute",
    borderTopLeftRadius: 4,
    borderBottomLeftRadius: 4,
    backgroundColor: theme.palette.primary.main,
  },
}));

const ListItemIconStyle = styled(ListItemIcon)({
  width: 22,
  height: 22,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
});

NavItem.propTypes = {
  item: PropTypes.object,
  active: PropTypes.func,
};
function NavItem({ item, active }) {
  const theme = useTheme();
  const isActiveRoot = active(item.path);
  const { title, path, icon, info, children } = item;
  const [open, setOpen] = useState(isActiveRoot);

  const handleOpen = () => {
    setOpen((prev) => !prev);
  };

  const activeRootStyle = {
    // color: "primary.main",
    fontWeight: "fontWeightMedium",
    backgroundColor: "#4C3795",
    // bgcolor: alpha(
    //   theme.palette.primary.main,
    //   theme.palette.action.selectedOpacity
    // ),
    "&:before": { display: "block" },
  };

  const activeSubStyle = {
    // color: "text.secondry",
    fontWeight: "fontWeightMedium",
    // backgroundColor: alpha(theme.palette.primary.main),
    backgroundColor: "#4C3795",
    // color: theme.palette.primary.main,
  };

  if (children) {
    return (
      <>
        <ListItemStyle
          onClick={handleOpen}
          sx={{
            ...(isActiveRoot && activeRootStyle),
          }}
        >
          <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
          <ListItemText disableTypography primary={title} />
          {info && info}
          {open ? (
            <KeyboardArrowUpIcon sx={{ fontSize: 16, marginLeft: 1 }} />
          ) : (
            <KeyboardArrowDownIcon sx={{ fontSize: 16, marginLeft: 1 }} />
          )}
        </ListItemStyle>

        <Collapse in={open} timeout="auto" unmountOnExit>
          <List component="div" disablePadding>
            {children.map((item) => {
              const { title, path } = item;
              const isActiveSub = active(path);

              return (
                <ListItemStyle
                  key={title}
                  component={RouterLink}
                  to={path}
                  sx={{
                    paddingLeft: "62px",
                    backgroundColor: alpha(
                      theme.palette.primary.main,
                      theme.palette.action.selectedOpacity,
                    ),
                    ...(isActiveSub && activeSubStyle),
                  }}
                >
                  <ListItemIconStyle>
                    {item.icon ? (
                      item.icon
                    ) : (
                      <Box
                        component="span"
                        sx={{
                          width: 4,
                          height: 4,
                          borderRadius: "50%",
                          bgcolor: "text.disabled",
                          ...(isActiveSub && {
                            transform: "scale(2)",
                            bgcolor: "primary.main",
                          }),
                        }}
                      />
                    )}
                  </ListItemIconStyle>

                  <ListItemText disableTypography primary={title} />
                </ListItemStyle>
              );
            })}
          </List>
        </Collapse>
      </>
    );
  }

  return (
    <ListItemStyle
      component={RouterLink}
      to={path}
      sx={{
        ...(isActiveRoot && activeRootStyle),
      }}
    >
      <ListItemIconStyle>{icon && icon}</ListItemIconStyle>
      <ListItemText disableTypography primary={title} />
      {info && info}
    </ListItemStyle>
  );
}

NavSection.propTypes = {
  navConfig: PropTypes.array,
};

export default function NavSection({ navConfig, ...other }) {
  const { pathname } = useLocation();
  const userData = JSON.parse(localStorage.getItem("user_data"));

  const superAdmin = userData?.roles[0]?.name;

  const permissions = userData?.roles[0]?.permissions?.map((p) => p.name) || [];

  const match = (path) =>
    path ? !!matchPath({ path, end: false }, pathname) : false;

  const filterNavConfig = (navItems, permissions) => {
    return navItems
      .map((item) => {
        if (permissions.includes(item.id)) {
          return item;
        }

        if (item.children) {
          const filteredChildren = item.children.filter((child) =>
            permissions.includes(child.id),
          );

          if (filteredChildren.length > 0) {
            return {
              ...item,
              children: filteredChildren,
            };
          }
        }

        return null;
      })
      .filter(Boolean);
  };

  const filteredNavConfig = filterNavConfig(navConfig, permissions);

  const finalNavConfig =
    superAdmin === "Super Admin" ? navConfig : filteredNavConfig;
  return (
    <Box {...other}>
      <List disablePadding sx={{ pt: 0.4, pb: 7 }}>
        {finalNavConfig.map((item) => (
          <NavItem key={item.title} item={item} active={match} />
        ))}
      </List>
    </Box>
  );
}
